import { routes } from "routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideAllMenus } from "store/application/application-action";

import "./styles/TrendingTag.scss";

interface ITrendingTagsProps {
  title: string;
  setSearchInput: (arg: string) => void;
  setCurrentTag: (arg: string[]) => void;
}

export const TrendingTag = ({ title, setSearchInput, setCurrentTag }: ITrendingTagsProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickSearchItem = () => {
    setSearchInput("");
    // @ts-ignore
    setCurrentTag(prev => {
      if (prev.includes(title)) {
        navigate(routes.multipleTag(prev));
        return prev;
      }

      if (prev.length >= 3){
        return prev;
      }

      navigate(routes.multipleTag([...prev, title]));
      return [...prev, title];
    });
    document?.getElementById("global-search-input")?.blur();
    dispatch(hideAllMenus());
  };

  return (
    <div className="TrendingTag" onClick={handleClickSearchItem}>
      <div className="TrendingTag-Circle" />
      <span>{ title }</span>
    </div>
  );
};
